import { TFunction } from "i18next";
import { SecondaryColor, SemanticColor } from "node-library/dist/colors";
import {
	FrontendInstanceTestStatusFilter,
	TestStatus,
} from "node-library/dist/constants";
import { SampleWithInstanceAndSpecSortColumn } from "node-library/dist/paginations";
import { FrontendAnalystViewSampleWithInstanceAndSpec } from "node-library/dist/portal";

export function getTestStatusForAnalyst(
	instance: FrontendAnalystViewSampleWithInstanceAndSpec
) {
	const testStatus: TestStatus = instance.sampleTestInfo?.status as TestStatus;
	switch (testStatus) {
		case TestStatus.SAMPLE_REGISTERED:
			return TestStatus.SAMPLE_REGISTERED;
		case TestStatus.IN_TESTING:
			//check if any viewable batch are created
			const anyBatchCreated: boolean =
				instance.sampleTestInfo?.selectedTests.some((test) => {
					return test.assignedBatchId !== null;
				}) || false;
			return anyBatchCreated
				? TestStatus.IN_TESTING
				: TestStatus.SAMPLE_REGISTERED;
		case TestStatus.REPORT_READY:
			return TestStatus.REPORT_READY;
	}
}

export function getTestStatusTranslationText(
	status: TestStatus,
	translation: TFunction<"translation", undefined>
): string {
	switch (status) {
		case TestStatus.SAMPLE_REGISTERED:
			return translation("SampleRegistered");
		case TestStatus.IN_TESTING:
			return translation("InTesting");
		case TestStatus.REPORT_READY:
			return translation("ReportReady");
	}
}

export function getInstanceStatusFilterTranslationText(
	status: FrontendInstanceTestStatusFilter,
	translation: TFunction<"translation", undefined>
) {
	switch (status) {
		case FrontendInstanceTestStatusFilter.IN_PROGRESS:
			return translation("InProgress");
		case FrontendInstanceTestStatusFilter.COMPLETE:
			return translation("Complete");
		case FrontendInstanceTestStatusFilter.ALL:
			return translation("All");
	}
}

export function getSampleWithInstanceAndSpecSortString(
	column: SampleWithInstanceAndSpecSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (column) {
		case SampleWithInstanceAndSpecSortColumn.EXPECTED_COMPLETION_TIME:
			return translation("DueDate");
		case SampleWithInstanceAndSpecSortColumn.SAMPLE_ID:
			return translation("SampleId");
	}
}

export function getTestStatusColors(status: TestStatus): {
	backgroundColor: string;
	borderColor: string;
	textColor: string;
} {
	switch (status) {
		case TestStatus.SAMPLE_REGISTERED:
			return {
				backgroundColor: SemanticColor.WARNING_100,
				borderColor: SemanticColor.WARNING,
				textColor: SemanticColor.WARNING_300,
			};
		case TestStatus.IN_TESTING:
			return {
				backgroundColor: SecondaryColor.SECONDARY_100,
				borderColor: SecondaryColor.SECONDARY_500,
				textColor: SecondaryColor.SECONDARY_600,
			};
		case TestStatus.REPORT_READY:
			return {
				backgroundColor: SemanticColor.SUCCESS_100,
				borderColor: SemanticColor.SUCCESS,
				textColor: SemanticColor.SUCCESS_300,
			};
	}
}
